import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService } from 'src/app/services/alert.service';

import * as _ from 'lodash';
import * as moment from 'moment';
import { RegisterService } from 'src/app/services/register.service';
import { RegionService } from 'src/app/services/region.service';

@Component({
  selector: 'app-applicantdetail-popup',
  templateUrl: './applicantdetail-popup.component.html',
  styleUrls: ['./applicantdetail-popup.component.scss']
})
export class ApplicantDetailPopupComponent implements OnInit {
  applicant_id: any;
  result: any;
  binaryFile: any;
  binaryFilePhoto: any;
  binaryFileAddressProof: any;
  pageType: any;

  
  constructor(
    public dialogRef: MatDialogRef<ApplicantDetailPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private regionService: RegionService,
    public dialog: MatDialog,
    private registerService: RegisterService) {
      this.applicant_id = this.data.applicant_id;
      this.pageType == this.data.pageType;
  }

  ngOnInit() {
    this.getApplicant();
  }
  getApplicant(){
    if(this.pageType == 1){
      this.regionService.getnewapplicant(this.applicant_id).subscribe(result => {
        this.result = result;
        this.regionService.getFile(result.value.photoproof_uploadid).subscribe(response => {
            
            this.binaryFilePhoto = response.value.binary;
        });
       
      });
    }else{
      this.regionService.getapplicantDetail(this.applicant_id).subscribe(result => {
        this.result = result;
        this.regionService.getFile(result.value.photoproof_uploadid).subscribe(response => {
            
            this.binaryFilePhoto = response.value.binary;
        });
      });
    }
    
  }

  download(id) {
    if (id) {
      this.regionService.getFile(id).subscribe(response => {
        if(response && response.isSuccess){
          this.binaryFile = response.value.binary;
          let a = document.createElement("a"); //Create <a>
          a.href = "data:application/octet-stream;base64," + response.value.binary;
          a.target = "new";
          a.download = response.value.filename +'.'+response.value.filetype; //File name Here
          a.click(); //Downloaded file
          a.remove();
        }else{
          if (response && response.failures) {
            this.alertService.error(response.failures.toString());
          }
        }
      });
    }
  }

  onCancel(isProceed) {
    this.dialogRef.close(isProceed);
  }


}
